// Initialize Google Analytics - Using HTML script method only
export const initGA = () => {
  // GA4 is fully handled via HTML script in index.html - no code needed here
};

// Track page views
export const trackPageView = (pagePath, pageTitle) => {
  if (window.gtag && process.env.REACT_APP_GA_TRACKING_ID) {
    window.gtag('config', process.env.REACT_APP_GA_TRACKING_ID, {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Track user interactions
export const trackProductView = (product) => {
  trackEvent('view_item', {
    currency: 'ZAR',
    value: product.price || 0,
    items: [{
      item_id: product._id || product.id,
      item_name: product.name,
      item_category: product.category,
      item_brand: product.shop?.name || 'Quick Runner',
      price: product.price || 0,
      quantity: 1,
      // Custom dimensions (mapped to standard or custom parameters)
      grading: product.grading,
      shop_name: product.shop?.name
    }]
  });
};

export const trackAddToCart = (product, quantity, variantInfo) => {
  trackEvent('add_to_cart', {
    currency: 'ZAR',
    value: (product.price || 0) * quantity,
    items: [{
      item_id: product._id || product.id,
      item_name: product.name,
      item_category: product.category,
      item_brand: product.shop?.name || 'Quick Runner',
      price: product.price || 0,
      quantity: quantity,
      item_variant: variantInfo,
      // Custom dimensions
      grading: product.grading,
      shop_name: product.shop?.name
    }]
  });
};

export const trackPurchase = (orderId, totalValue, products, runnerName) => {
  trackEvent('purchase', {
    transaction_id: orderId,
    currency: 'ZAR',
    value: totalValue,
    runner_name: runnerName, // Custom parameter
    items: products.map(product => ({
      item_id: product.productId || product.id || product._id,
      item_name: product.name,
      item_category: product.category,
      item_brand: product.shop?.name || 'Quick Runner',
      price: product.price || 0,
      quantity: product.quantity,
      item_variant: `${product.color || ''} ${product.size || ''}`.trim(),
      // Custom dimensions
      shop_name: product.shop?.name,
      grading: product.grading
    }))
  });
};

// Track user engagement
export const trackUserLogin = (method) => {
  trackEvent('login', {
    method: method
  });
};

export const trackUserSignup = (method) => {
  trackEvent('sign_up', {
    method: method
  });
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  trackEvent('form_submit', {
    form_name: formName
  });
};

// Track search
export const trackSearch = (searchTerm) => {
  trackEvent('search', {
    search_term: searchTerm
  });
};

// Track WhatsApp interactions
export const trackWhatsAppClick = () => {
  trackEvent('contact_whatsapp', {
    contact_method: 'whatsapp'
  });
};

// Track CTA clicks
export const trackCTAClick = (ctaText, location) => {
  trackEvent('cta_click', {
    cta_text: ctaText,
    location: location
  });
};
